
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pt-br/ia/coleta-de-documentos",
      function () {
        return require("private-next-pages/pt-br/ia/coleta-de-documentos/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pt-br/ia/coleta-de-documentos"])
      });
    }
  